import { Component, OnInit } from '@angular/core';
import { Settings, AppSettings } from '../../app.settings';
import { AppService } from '../../app.service';
import { Property, Pagination } from '../../app.models';

import { Subscription } from 'rxjs';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PagesService } from '../pages.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {


  watcher: Subscription;
  activeMediaQuery = '';
  show
  public slides = [];
  public propertyData : any[] = [];
  public properties: Property[];
  public viewType: string = 'grid';
  public viewCol: number = 25;
  public count: number = 8;
  public sort: string;
  public searchFields: any;
  public removedSearchField: string;
  public pagination: Pagination = new Pagination(1, 8, null, 2, 0, 0);
  public message: string;
  public featuredProperties: Property[];
  activeTab = '';
  blogs = [];
  public settings: Settings;
  constructor(public appSettings: AppSettings, public router: Router, public appService: AppService, public mediaObserver: MediaObserver, public pagesServices: PagesService, private route: ActivatedRoute, public snackBar: MatSnackBar) {
    this.settings = this.appSettings.settings;

    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change.mqAlias == 'xs') {
        this.viewCol = 100;
      }
      else if (change.mqAlias == 'sm') {
        this.viewCol = 50;
      }
      else if (change.mqAlias == 'md') {
        this.viewCol = 33.3;
      }
      else {
        this.viewCol = 25;
      }
    });

  }

  ngOnInit() {
    const param = this.route.snapshot.queryParamMap.get('email');
    if(param){
      this.snackBar.open('Email has been verified Successfully, You can Login Now', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
    }
    this.getSlides();
    this.getAllUserProperty()
    this.getFeaturedProperties();
    this.getBlogs()
    this.activeTab = "Sale";
    window.onscroll = function (e) {
      if (window.scrollY == 0) {
        if(document.getElementById("arrows")) {
          document.getElementById("arrows").style.display = "block";
        }
      } else {
        if(document.getElementById("arrows")) {
          document.getElementById("arrows").style.display = "none";
        }
        
      }
    }
    
    this.route.queryParams.subscribe((params) => {
      if(params?.link)
      this.setActive(params.link)
      }
    );
  }

  getBlogs() {
    this.pagesServices.getAllBlogs().then(res => {
      this.blogs = res.blogs
    })
  }
  getAllUserProperty(page = 1){
    this.pagesServices.getAllUserProperties(this.pagination.perPage ,page).then((res: any) => {
      if (res.success) {
        this.propertyData = res.property;
        this.pagination.total = res.count;
      }
    })  
  }

  ngDoCheck() {
    if (this.settings.loadMore.load) {
      this.settings.loadMore.load = false;
      this.getProperties();
    }
  }

  ngOnDestroy() {
    this.resetLoadMore();
    this.watcher.unsubscribe();
  }

  public getSlides() {
    this.appService.getHomeCarouselSlides().subscribe(res => {
      this.slides = res;
    })
  }

  setActive(tab) {
    this.activeTab = tab;
  }

  openDetails(item) {
    let title = item.title.replaceAll(' ','-')
    this.router.navigate([`/news/${title}/${item._id}`]);
  }


  public getProperties() {
    this.appService.getProperties().subscribe(data => {
      if (this.properties && this.properties.length > 0) {
        this.settings.loadMore.page++;
        this.pagination.page = this.settings.loadMore.page;
      }
      let result = this.filterData(data);
      if (result.data.length == 0) {
        this.properties.length = 0;
        this.pagination = new Pagination(1, this.count, null, 2, 0, 0);
        this.message = 'No Results Found';
        return false;
      }
      if (this.properties && this.properties.length > 0) {
        this.properties = this.properties.concat(result.data);
      }
      else {
        this.properties = result.data;
      }
      this.pagination = result.pagination;
      this.message = null;

      if (this.properties.length == this.pagination.total) {
        this.settings.loadMore.complete = true;
        this.settings.loadMore.result = this.properties.length;
      }
      else {
        this.settings.loadMore.complete = false;
      }
    })
  }

  public resetLoadMore() {
    this.settings.loadMore.complete = false;
    this.settings.loadMore.start = false;
    this.settings.loadMore.page = 1;
    this.pagination = new Pagination(1, this.count, null, null, this.pagination.total, this.pagination.totalPages);
  }

  public filterData(data) {
    return this.appService.filterData(data, this.searchFields, this.sort, this.pagination.page, this.pagination.perPage);
  }

  public searchClicked() {
    this.properties.length = 0;
    this.getProperties();
  }
  public searchChanged(event) {
    event.valueChanges.subscribe(() => {
      this.resetLoadMore();
      this.searchFields = event.value;
      setTimeout(() => {
        this.removedSearchField = null;
      });
      if (!this.settings.searchOnBtnClick) {
        this.properties.length = 0;
      }
    });
    event.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe(() => {
      if (!this.settings.searchOnBtnClick) {
        this.getProperties();
      }
    });
  }
  public removeSearchField(field) {
    this.message = null;
    this.removedSearchField = field;
  }



  public changeCount(count) {
    this.count = count;
    this.resetLoadMore();
    this.properties.length = 0;
    this.getProperties();

  }
  public changeSorting(sort) {
    this.sort = sort;
    this.resetLoadMore();
    this.properties.length = 0;
    this.getProperties();
  }
  public changeViewType(obj) {
    this.viewType = obj.viewType;
    this.viewCol = obj.viewCol;
  }


  public getFeaturedProperties() {
    this.appService.getFeaturedProperties().subscribe(properties => {
      this.featuredProperties = properties;
    })
  }
  public onPageChange(e){ 
    this.count = e.pageSize;
    this.getAllUserProperty(e.pageIndex + 1)
  }

  viewAll() {
    this.router.navigate(['/news']);
  }

}
